<script>
import { mapActions } from "vuex";
import { required, minLength, maxLength, sameAs } from "vuelidate/lib/validators"; // for validators
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Layout from "../../layouts/main";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error';
import { VueContentLoading } from 'vue-content-loading';

export default {
    page: {
        title: "تعديل بيانات المدير",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, AlertError, VueContentLoading },
    data() {
        return {

        // title
        title: "تعديل بيانات المدير",
        items: [
            {
                text: "ادارة المدراء",
                href: "/admins",
            },
            {
                text: "تعديل بيانات المدير",
                active: true,
            },
        ],

        //Page errors.
        errors: [],

        // vuelidate
        id: this.$route.params.id,
        password: '',
        password_confirmation: '',
        submitadd: false,
        loadingButton: false,

        loadingContent: true
        };
    },
    // vuelidate
    validations: {
        password:
        {
            required,
            minLength: minLength(8),
            maxLength: maxLength(50)
        },
        password_confirmation:
        {
            required,
            sameAsPassword: sameAs("password")
        },
    },
    methods: {
        ...mapActions('admin', ['resetPassword']),
        handleError(error){
            if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
            else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
        },
        resetForm(){
            this.submitadd = false
            this.loadingButton = false
            this.errors = []
            this.password = ''
            this.password_confirmation = ''
        },
        formResetPasswordAdmin() { 
            this.submitadd = true
            this.$v.$touch();
            if(this.$v.$error) return

            // to form submit after this
            this.loadingButton = true
            this.errors = [];

            this.resetPassword({
                id: this.id, 
                data: {
                    password: this.password,
                    password_confirmation: this.password_confirmation
                }
            })
            .then((response)=>{
                swal.success(response.data.message)
                this.loadingButton = false
                this.resetForm()
            })
            .catch((error)=>{
                this.handleError(error)
                this.loadingButton = false
            })
        }
    },
    mounted() {
        setTimeout(() => {
        this.loadingContent = false;
        }, 1000);
    }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <AlertError :errors="errors" />

            <b-form v-if="!loadingContent" @submit.prevent="formResetPasswordAdmin">

                <hr class="mt-4"> <div class="break-title"><h5 class="mb-4">اعادة تعيين كلمة المرور</h5></div>
                <div class="row">
                    <b-form-group class="col-md-6 mb-3" label=" كلمة المرور الجديدة :" label-for="new_pass">
                        <b-form-input v-model="password" :class="{ 'is-invalid': submitadd && $v.password.$error }" id="new_pass" type="text" placeholder="ادخل كلمة المرور الجديدة"></b-form-input>
                        <div v-if="submitadd && $v.password.$error" class="invalid-feedback">
                        <span v-if="!$v.password.required"> هذا الحقل الزامي </span>
                        <span v-if="!$v.password.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 8 احرف على الاقل . </span>
                        <span v-if="!$v.password.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 50 حرف على الاكثر . </span>
                        </div>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-3" label="تأكيد كلمة المرور الجديدة :" label-for="confirm_pass">
                        <b-form-input v-model="password_confirmation" :class="{ 'is-invalid': submitadd && $v.password_confirmation.$error }" id="confirm_pass" type="text" placeholder="ادخل كلمة المرور الجديدة"></b-form-input>
                        <div v-if="submitadd && $v.password_confirmation.$error" class="invalid-feedback">
                        <span v-if="!$v.password_confirmation.required"> هذا الحقل الزامي </span>
                        <span v-if="!$v.password_confirmation.sameAsPassword"> كلمة المرور غير متطابقة </span>
                        </div>
                    </b-form-group>
                </div>

                <div>
                    <hr>
                    <b-button type="submit" variant="primary" :disabled="loadingButton">
                        <b-spinner v-if="loadingButton" small></b-spinner> 
                        <span v-else>
                            <i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ
                        </span>
                    </b-button>

                    <router-link :to="{ name: 'admins.index'}">
                        <b-button class="f-left" type="button" variant="secondary">رجوع</b-button>
                    </router-link>
                </div>

            </b-form>

            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="56">
                <rect x="0" y="4" rx="0" ry="0" width="2" height="7" />
                <rect x="4" y="6" rx="1" ry="1" width="30" height="3" />
                <rect x="35" y="7" rx="1" ry="1" width="364" height="1" />

                <rect x="0" y="17" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="21" rx="1" ry="1" width="197" height="10" />
                <rect x="203" y="17" rx="1" ry="1" width="50" height="2" />
                <rect x="203" y="21" rx="1" ry="1" width="197" height="10" />

                <rect x="0" y="41" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="45" rx="1" ry="1" width="20" height="10" />
                <rect x="385" y="45" rx="1" ry="1" width="15" height="10" />
              </vue-content-loading>
            </div>


          </div>
        </div>
      </div>
    </div>
    
  </Layout>
</template>